import InstitutionScheduleTable from "./InstitutionScheduleTable.vue";

export default {
  extends: InstitutionScheduleTable
};
